import { Component } from 'react';
import { connect } from 'react-redux';

import { Layout, Title } from 'common/components/layout';
import SubMenu from 'profile/common/SubMenu';
import { hasClubs, hasLoyalty } from 'profile/common/helpers';
import { listClubMemberships } from 'redux/clubMemberships/actions';
import { listCustomerAddresses } from 'redux/customerAddresses/actions';
import { listCustomerCreditCards } from 'redux/customerCreditCards/actions';
import { listOrders } from 'redux/orders/actions';

import AddressBook from './components/AddressBook';
import ClubMembers from './components/ClubMembers';
import CreditCards from './components/CreditCards';
import Loyalty from './components/Loyalty';
import OrderHistory from './components/OrderHistory';
import Profile from './components/Profile';
import WelcomeMessage from './components/WelcomeMessage';

// import NextShipment from './important/NextShipment';
// import ShipmentOnHold from './important/ShipmentOnHold';
// import ExpiredPayment from './important/ExpiredPayment';

class Dashboard extends Component {
  componentDidMount() {
    const { props } = this;
    props.listOrders();
    props.listCustomerAddresses();
    props.listCustomerCreditCards();
    props.listClubMemberships();
  }

  render() {
    const { customer, settings, orders, clubs } = this.props;

    if (!settings.data || !customer.data) {
      return (
        <Layout title="Dashboard" loading>
          <Title>Your Account</Title>
        </Layout>
      );
    }
    return (
      <Layout title="Dashboard">
        <Title>Your Account</Title>
        <SubMenu />

        <div className="c7-account__dashboard">
          <h2>Dashboard</h2>
          <WelcomeMessage customer={customer.data} settings={settings} />
          {/*
          <NextShipment />
          <ShipmentOnHold />
          <ExpiredPayment />
          */}

          <OrderHistory orders={orders} settings={settings} />
          <div className="c7-account-row">
            <Profile customer={customer.data} />
            {hasClubs(clubs) && <ClubMembers />}
            {!hasClubs(clubs) && hasLoyalty(settings) && <Loyalty />}
          </div>

          {hasClubs(clubs) && hasLoyalty(settings) && (
            <div className="c7-account-row">
              <Loyalty />
            </div>
          )}

          <div className="c7-account-row">
            <AddressBook />
            <CreditCards />
          </div>
        </div>
      </Layout>
    );
  }
}

const mapStateToProps = (state) => ({
  customer: state.customer,
  settings: state.setting,
  orders: state.order,
  clubs: state.club
});

export default connect(mapStateToProps, {
  listOrders,
  listCustomerAddresses,
  listCustomerCreditCards,
  listClubMemberships
})(Dashboard);
